import api from "../services/api";


export const fetchCashouts = async (page = 1, size = 10) => {
  try {
    const response = await api.get(
      `/cashout_management/all?page=${page}&size=${size}`
    );

    if (response.status === 200) {
      return { success: true, data: response.data.data };
    } else {
      return { success: false, error: "Unexpected response from server" };
    }
  } catch (error) {
    return { success: false, error: error.message || "Failed to fetch cashouts" };
  }
};


export const updateCashoutStatus = async (cashoutId, payload) => {
  try {
    const response = await api.put(
      `/cashout_management/update/${cashoutId}`,
      payload
    );

    if (response.status === 200) {
      return { success: true, data: response.data.data };
    } else {
      return { success: false, error: "Unexpected response from server" };
    }
  } catch (error) {
    return { success: false, error: error.message || "Failed to update cashout" };
  }
};